// extracted by mini-css-extract-plugin
export default {"tx":"efc03c1bc9","line":"cae4f9af22"};